import { render, staticRenderFns } from "./part-none.vue?vue&type=template&id=920d424a&scoped=true"
import script from "./part-none.vue?vue&type=script&lang=js"
export * from "./part-none.vue?vue&type=script&lang=js"
import style0 from "./part-none.vue?vue&type=style&index=0&id=920d424a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920d424a",
  null
  
)

export default component.exports